import React, { useEffect, useRef, useState } from 'react';
import { accountFormIsVisible, sessionKey } from '../../redux/selectors/pagesSelectors';
import {
    checkKey,
    setAccountFormIsVisible,
    setAccountFormRegisterState,
} from '../../redux/actions/pagesActions';
import { connect } from 'react-redux';
import { authAvatarUrlSelector, authEmailSelector } from '../../redux/selectors/authSelectors';
import { logout } from '../../redux/actions/authActions';
import { productCurrentProductIdSelector } from '../../redux/selectors/productSelector';
import { ReactComponent as ChevronDownIcon } from '../../svg/chevron-down.svg';
import { ReactComponent as UserIcon } from '../../svg/user.svg';

function RegisterBlock({
    email,
    checkKey,
    logout,
    setFormState,
    setFormIsVisible,
    mainProductId,
    avatarUrl,
}) {

    const [isOpened, setIsOpened] = useState(false);

    const menuTitleRef = useRef();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!menuTitleRef.current || !isOpened) return;

            if (!menuTitleRef.current.contains(e.target)) {
                setIsOpened(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        }
    }, [isOpened]);

    useEffect(() => {
        checkKey();
    }, [checkKey]);

    const openRegistrationForm = () => {
        setFormState(false);
        setFormIsVisible(true);
    };

    const openLoginForm = () => {
        setFormState(true);
        setFormIsVisible(true);
    };

    const logoutHandler = () => {
        logout({ product_id: mainProductId });
        setIsOpened(false);
    };

    return (
        <div className={'header__user-info header__link-border'}>
            {email ? (
                <ul className={'header__list'}>
                    <li className={'header__li'}>
                        <div className={'header__email-block'}>
                            <span className={'color--gray hide-tablet pr-4'}>
                                Account is
                            </span>{' '}
                            <span className={'header__mail'}>{email}</span>
                        </div>
                    </li>

                    <li ref={menuTitleRef} className={'header__li relative'}>

                        <div
                            className={'header__profile-icon flex flex--center cursor--pointer'}
                            onClick={() => setIsOpened((prev) => !prev)}
                        >

                            {avatarUrl ? (
                                <img src={avatarUrl} alt="User Avatar" className='size-23 mr-4 b-radius-50' />
                            ) : (
                                <UserIcon className={'icon size-23 color--gray mr-4'} />
                            )}

                            <ChevronDownIcon className={`icon size-20 color--gray icon--rotated ${isOpened ? 'icon--rotated-180' : ''}`} />
                        </div>

                        <ul className={`header__menu ${isOpened ? 'header__menu--opened' : ''}`}>
                            <li>
                                <a
                                    href="https://cleantalk.org/my/"
                                    className={'header__menu-link'}
                                >
                                    Dashboard
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://cleantalk.org/my/payments"
                                    className={'header__menu-link'}
                                >
                                    Licenses, Payments & Invoice
                                </a>
                            </li>
                            <li>
                                <button
                                    type={'button'}
                                    onClick={logoutHandler}
                                    className={'header__menu-link color--gray cursor--pointer button--reset'}
                                >
                                    Log out
                                </button>
                            </li>
                        </ul>
                    </li>
                </ul>
            ) : (
                <ul className={'header__list'}>
                    <li className={'header__li'}>
                        <button onClick={openLoginForm} className={'button--reset'}>
                            <span className={'text-3 color--blue'}>Sign In</span>
                        </button>
                    </li>
                    <li className={'header__li'}>
                        <button
                            onClick={openRegistrationForm}
                            className={'button--reset text color--blue-2'}
                        >
                            <span className={'text-3 color--blue'}>Create account</span>
                        </button>
                    </li>
                </ul>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    sessionKey: sessionKey(state),
    email: authEmailSelector(state),
    avatarUrl: authAvatarUrlSelector(state),
    formIsVisible: accountFormIsVisible(state),
    mainProductId: productCurrentProductIdSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkKey: (data) => dispatch(checkKey(data)),
    logout: (params) => dispatch(logout(params)),
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
    setFormState: (flag) => dispatch(setAccountFormRegisterState(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterBlock);
